import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useSystem } from "@/utils/hooks/useLocation";
// ******* Queries *******

export const useGetDeparturesQuery = (params = {}) => {
  const { axiosProtected } = useAxios();
  const { currentSystem } = useSystem();

  // Build query parameters
  const queryParams = new URLSearchParams();

  // Add search parameter if provided
  if (params.query && params.query.trim()) {
    queryParams.append("query", params.query.trim());
  }

  // Add other parameters if needed
  Object.keys(params).forEach((key) => {
    if (
      key !== "query" &&
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      queryParams.append(key, params[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = queryString ? `${currentSystem}/departures?${queryString}` : `${currentSystem}/departures-makkah`;

  return useQuery({
    queryKey: ["departures-makkah", params],
    queryFn: () => axiosProtected.get(url),
  });
};

export const useGetOneDepartureQuery = ({ id }) => {
  const { axiosProtected } = useAxios();
  const { currentSystem } = useSystem();

  return useQuery({
    queryKey: ["one-departure", id],
    queryFn: () => axiosProtected.get(`${currentSystem}/departures-makkah/${id}`),
    enabled: !!id,
  });
};

// ******* Mutations *******

export const useImportDepartureMutation = () => {
  const { axiosProtected } = useAxios();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { currentSystem } = useSystem();

  return useMutation({
    mutationFn: async (file) => {
      const formData = new FormData();
      formData.append("file", file);

      return axiosProtected.post(`${currentSystem}/departure-campaigns/import`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      toast.success(
        t("DEPARTURE_IMPORTED_SUCCESSFULLY") || "تم استيراد حملات المغادرة بنجاح"
      );
      queryClient.invalidateQueries({ queryKey: ["departures-makkah"] });
    },
    onError: (err) => {
      console.error("Departure import error:", err);
      toast.error(
        err?.response?.data?.message ||
          t("DEPARTURE_IMPORT_FAILED") ||
          "فشل استيراد حملات المغادرة"
      );
    },
  });
};

